import { Button, Card, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const DemoBanner = () => {
	const { translate } = useLocales();
	const isDownX = useMediaQuery("(max-width:1010px)");

	const onClick = () => {
		window.open("https://docs.vumi.io/", "_blank");
	};

	return (
		<Card
			sx={{
				mx: { xl: 40, lg: 30, md: 12, sm: 10, xs: 6 },
				mt: 4,
				p: 3,
				mb: 10,
				maxWidth: isDownX ? 400 : 950
			}}
		>
			<Grid container gap={3} alignItems={"center"}>
				<Grid item>
					<Image src={"/ilustrations/static_website.svg"} sx={{ maxHeight: 250 }} />
				</Grid>
				<Grid item>
					<Stack gap={1}>
						<Typography color='text.primary' variant={"h4"}>
							{translate("demo.banner_title")}
						</Typography>
						<Typography color='text.secondary' variant={"body1"} maxWidth={590}>
							{translate("demo.banner_title_des")}
						</Typography>
						<Button variant='contained' sx={{ mt: 2, maxWidth: 180 }} onClick={onClick}>
							{translate("demo.see_doc")}
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</Card>
	);
};

export default DemoBanner;
